<div style="text-align: center">
  <h5 *ngIf="!message" style="font-size: 20px; margin-top: 10px">404 Not Found</h5>
  <div *ngIf="message">
    <div class="alert alert-danger">
      <strong>Error: </strong> {{ message }}
      <div>
        <span><strong>Tenant ID: </strong> {{ tenantID }}</span>
        <span><strong>Property ID: </strong>{{ propertyID }}</span>
      </div>
    </div>
  </div>
</div>
